import { axios } from './config';

export const getPageLevelScriptConfig = (siteId) => {
	return axios.get(`/page-level-script-config/${siteId}`);
};

export const syncSinglePageLevelScriptConfig = (payload) => {
	return axios.post(`/page-level-script-config/sync-single`, payload);
};

export const syncBulkPageLevelScriptConfig = (payload) => {
	return axios.post(`/page-level-script-config/sync-bulk`, payload);
};

export const createPageLevelScriptConfig = (payload) => {
	return axios.post(`/page-level-script-config/create-config`, payload);
};

export const updatePageLevelScriptConfig = (payload) => {
	return axios.post(`/page-level-script-config/update-config`, payload);
};
